import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { QRCodeComponent } from 'angularx-qrcode';
import { ChartConfiguration, ChartData, ChartType, ChartEvent } from 'chart.js';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { filter, Subject, takeUntil } from 'rxjs';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { TemplateRefDiamondsService } from 'src/app/customers/layout/component-layout/profile-character/level-profile/diamonds-popup/template-ref-diamonds.service';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { REGION_CATEGORY_IMAGE_LIST } from 'src/app/customers/marketplace/marketplace.model';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { User } from 'src/app/shareModule/models/user.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { environment } from 'src/environments/environment';
import { CERTIFICATE_LIST } from '../../../roles/roles.model';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectorRef } from '@angular/core';

declare const google: any;

@Component({
  selector: 'app-profile-me',
  templateUrl: './profile-me.component.html',
  styleUrls: ['./profile-me.component.scss'],
})
export class ProfileMeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public openList: boolean = false;
  public openShepherd: boolean = false;
  public questList: Array<any> = [];
  tutorials: boolean;
  imgUrl: string = environment.ImageUrl + 'public/images/certificate/';

  constructor(
    public local: LocalServiceService,
    private auth: AuthServiceService,
    public sharedService: SharedService,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private myModalService: ModalService,
    private customerService: CustomerService,
    public roleService: RoleService,
    private store: Store<AppState>,

    private toastr: ToastrService,
    private modalService: NgbModal,
    private router: Router,
    private clipboard: Clipboard,
    private cdr: ChangeDetectorRef
  ) {
    if (this.sharedService.isBrowser()) {
      this.tutorials = JSON.parse(localStorage.getItem('tutorials')) || false;
    }

  }



  ngOnInit(): void {
    this.sharedService.profileService$.subscribe((data) => {
      this.getFavoriteProducts()
    });
    this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
      this.profileInfo = structuredClone(r || {});
      this._getFavoriteProductList();
      this.diamonds = r?.diamonds || '0';
      this._getQuestList();


      this.profileInfo.certificates = this.profileInfo?.certificates.filter(
        (row: any) => row.role != '' && row.role != null
      );

      this.postalCode = this.profileInfo.postalCode
      try{
        this.profileInfo.certified = JSON.parse(this.profileInfo.certified);
      }catch(e){
        this.profileInfo.certified = []
        console.error(e)
      }
      this.profileInfo.created = this.convertDate(this.profileInfo.created);
      this.profileInfo.isSupport = this.checkSupport();

      this.initMap()

      this.getProfileMatrix();
      this.getAllProductList();
      this.getFavoriteProducts()
      this.getSupported();
    });
  }

  ngOnDestroy(): void {
    // console.log('[Start Destroy] Profile Me')
    this.local.clearTimeout(this.timeout1)
    this.local.clearTimeout(this.timeout2)
    this.local.clearTimeout(this.timeout3)
    this.local.clearTimeout(this.timeout4)
    this.destroy$.next();
    this.destroy$.complete();
    // console.log('[End Destroy] Profile Me')
  }

  timeout1: any;
  openShopPopup(tab1, tab2) {
    this.sharedService.triggerInitTabProfile(tab1);
    this.local.clearTimeout(this.timeout1)
    this.timeout1 = setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(tab2);
      this.sharedService.shepherd('add-product');
    }, 1000);
  }

  openBuyDiamonds() {
    const signinPopup = this.templateRefDiamondsService.getDiamondsPopup();
    if (signinPopup) {
      this.myModalService.open(signinPopup, {
        size: 'md',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'diamondsPopup',
      });
    }
  }
  profileInfo: any = '';
  public diamonds: any = '0';
  public maskNumber(number: any): string {
    return number ? number.toString().replace(/\d(?=\d{4})/g, '*') : '';
  }



  private _getFavoriteProductList() {
    this.auth
      .marketplace_favorite_product_profile({
        isAdmin: this.local.getUser()?.role == 'admin',
      })

      .subscribe((response: any) => {
        this.profileInfo = { ...this.profileInfo, favorites: response.body};
      });
  }

  timeout2: any;
  openAvatarPopup() {
    this.sharedService.triggerInitTabProfile('profileCharacter');
    this.local.clearTimeout(this.timeout2)
    this.timeout2 = setTimeout(() => {
      this.sharedService.triggerInitProfile(1);
    }, 100);
  }

  timeout3: any;
  openSettingPopup() {
    // this.sharedService.triggerInitTabProfile('profile');
    this.sharedService.triggerInitTabProfile('profileCharacter');
    this.local.clearTimeout(this.timeout3)
    this.timeout3 = setTimeout(() => {
      this.sharedService.triggerInitProfile(4);
    }, 100);
  }

  private _getQuestList() {
    this.auth.getAllMemberQuestLevel().subscribe((resp: ApiResponse) => {
      if (resp.body && resp.body.length > 0) {
        let emailQuests = {};
        this.questList = resp.body
          .map((i: any) => {
            if (i.questKey == 'PRODUCT' && this.tutorials) {
              i.myFun = () => this.openShopPopup('shop', 0);
            }
            if (i.questKey == 'EMAIL' && this.tutorials) {
              i.myFun = () => this.sharedService.shepherd('verify-email');
            }
            if (
              i.questKey == 'PRODUCT' &&
              this.profileInfo.numberOfMemberShopProduct > 0
            ) {
              i['status'] = 'completed';
            }
            if (i.questKey == 'EMAIL' && this.profileInfo.email) {
              i['status'] = 'completed';
            }
            if (
              i.questKey == 'SUGGESTION' &&
              this.profileInfo.suggestionsCount > 0
            ) {
              i['status'] = 'completed';
            }
            if (
              i.questKey == 'FAVORITES' &&
              this.profileInfo.favorites &&
              this.profileInfo.favorites.length > 0
            ) {
              i['status'] = 'completed';
            }
            if (i.questKey == 'ARTICLE' && this.profileInfo.numberOfNews > 0) {
              i['status'] = 'completed';
            }
            if (
              i.questKey == 'NEW_FORUM' &&
              this.profileInfo.forumPostsCount > 0
            ) {
              i['status'] = 'completed';
            }
            if (
              i.questKey == 'ANSWER_FORUM' &&
              this.profileInfo.numberForumReply > 0
            ) {
              i['status'] = 'completed';
            }

            return i;
          })
          .filter((i: any) => {
            if (i.questLevels && i.questLevels.length > 0) {
              let min = 0,
                max = 0;
              for (let level of i.questLevels) {
                if (level && level.levelID && level.levelID > max) {
                  max = level.levelID;
                }
                if (level && level.levelID && level.levelID < min) {
                  min = level.levelID;
                }
              }

              return (
                this.profileInfo.level >= min && this.profileInfo.level <= max
              );
            }
            return false;
          })
          .filter((e: any) => {
            if (e.questKey == 'EMAIL') {
              emailQuests = e;
            } else {
              return e;
            }
          });
        if (this.questList.length > 0) {
          this.questList.splice(1, 0, emailQuests);
        }
      }
    });
  }










  public radarChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    aspectRatio: 1,
    layout: {
      padding: 0,
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  chartPopup: boolean = false;
  public radarChartLabels: string[] = [
    'Account Age',
    'No of Supporters',
    'Avg Level of Supporters',
    // 'Number of Orders',
    'No of Conversations',
    'Special Stats',
  ];

  public radarChartData: ChartData<'radar'> = {
    labels: this.radarChartLabels,
    datasets: [{ data: [0, 0, 0, 0, 0], label: '' }],
  };
  public radarChartType: ChartType = 'radar';

  // events
  public chartClicked({
    event,
    active,
  }: {
    event: ChartEvent;
    active: object[];
  }): void {

  }

  public chartHovered({
    event,
    active,
  }: {
    event: ChartEvent;
    active: object[];
  }): void {

  }

  @ViewChild('marketplace') marketplaceProfileSection: MarketplacePageComponent;
  @ViewChild('qrcode', { static: false }) qrcode: QRCodeComponent;

  public refer_friend_link: string = '';
  public subCategoryList: Array<any> = [];
  public totalMemberShopProductList: Array<any> = [];
  public currentCategoryName: string = '';
  public roles = CERTIFICATE_LIST;
  public certificateImgUrl: string =
    environment.ImageUrl + 'public/images/certificate/';

  async share(link) {
    if ('share' in navigator) {
      try {
        await navigator.share({
          url: link
        })
      } catch (e) {
        console.error(e);
        this.toastr.error("Something went wrong while sharing")
      }
    } else {
      this.toastr.info("Your browser doesn't support Share API")
    }
  }

  viewGrid: boolean = true;
  public tabs = [
    { title: 'Favorites' },
    { title: 'Sell' },
    { title: 'Rent' },
    { title: 'Donate' },
    { title: 'History' },
  ];
  loading = true;
  updateSelMenu(index: number) {
    this.selectMenu(index);
  }
  @ViewChild('AddShop') addProductComponent: AddProductComponent;

  handleChatNow() {
    this.sharedService.triggerChatNow({
      chatingNow: this.profile?.id,
      menu: 'chat',
      chatTitle: this.profileInfo.profileCharacterName ?? 'User',
      lastSeenTime: this.profileInfo.lastSeenTime,
    });
    // this.sharedService.triggerChatNow({ chatingNow: this.profile?.id, menu: 'chat', chatTitle: this.profileInfo.profileCharacterName ?? "User" });
  }

  public categoriesList: Array<any> = [];
  public subcategoriesList: Array<any> = [];
  public regionList = REGION_CATEGORY_IMAGE_LIST;
  public selectedCategoryName = null;
  public selectedSubCategoryName = '';
  public shopExist: boolean = true;

  public addedCategoryList: Array<any> = [];
  public addedSubCategoryList: Array<any> = [];
  public selectedRegionForDD = '';
  public commonModalRef: any = null;
  public selectedSellOption: any = null;
  public profile: any = {
    certificates: [],
    appUserSupports: [],
  };

  title = 'My Angular Google Maps App';
  lat: number = 1.3521;
  lng: number = 103.8198;
  map: any;
  geocoder: any;
  marker: any;
  postalCode: string = '';
  address: string = '';
  appUserId: any;
  isLogin: any = 0;

  tabs2 = [{ title: 'friends' }, { title: 'gallery' }];
  carouselOptionsSupported: any = {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      },
    },
  };





  checkIfLogin() {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isLogin = 1;
        this.profile.isSupport = this.checkSupport();
      } else {
        this.isLogin = 0;
      }
    });
  }
  sortDirection: 'asc' | 'desc' = 'asc';
  sortName: string = '';
  sortProducts(property: any): void {
    this.sortName = property;
    const multiplier = this.sortDirection === 'asc' ? 1 : -1;

    this.productAllProductList.sort((a, b) => {
      let comparison = 0;

      if (property === 'name') {
        comparison = a.name.localeCompare(b.name);
      } else if (property === 'price') {
        comparison =
          a.memberShopProductsVariations[0].key -
          b.memberShopProductsVariations[0].key;
      } else if (property === 'created') {
        comparison = a.created - b.created;
      }
      return comparison * multiplier;
    });

    // Toggle the sort direction for next click
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }

  checkSupport() {
    //console.log("Checking support ", this.appUserId)
    return (
      this.profileInfo.appUserSupports?.some(
        (row: any) => row.member_id == this.appUserId
      )
    );
  }

  public getProfileInfo(code: any) {
    this.customerService.getProfileInfo(code, true).subscribe(
      (response: any) => {
        this.refer_friend_link =
          window.location.protocol +
          '//' +
          window.location.hostname +
          '/profile/' +
          code;
        this.profile = response.body;

        this.profileInfo.certificates = this.profile?.certificates.filter(
          (row: any) => row.role != '' && row.role != null
        );

        if (this.profileInfo.id == null) {
          this.toastr.warning('Invalid Link');
          this.router.navigateByUrl('/me/nearby');
          return;
        }
        try{
          this.profileInfo.certified = JSON.parse(this.profileInfo.certified);
        }catch(e){
          this.profileInfo.certified = []
          console.error(e)
        }
        this.profileInfo.created = this.convertDate(this.profileInfo.created);
        this.profileInfo.isSupport = this.checkSupport();


        this.postalCode = this.profileInfo.postalCode;
        this.getProfileMatrix();
        this.getAllProductList();
        this.getSupported();
        this.loading = false;
      },
      (e) => {
        this.toastr.warning('Invalid Link');
        this.router.navigateByUrl('/me/nearby');
        this.loading = false;
      }
    );
  }

  public getProfileMatrix() {
    this.customerService
      .getProfileMatrix(this.profileInfo.id)
      .subscribe((response: any) => {
        this.profileInfo.matrix = response.body;
        this.radarChartData = {
          ...this.radarChartData,
          datasets: [
            {
              ...this.radarChartData.datasets[0],
              data: [
                this.profileInfo.matrix.accountAge,
                this.profileInfo.matrix.supporterCount,
                this.profileInfo.matrix.avgLevelOfSupporters,
                this.profileInfo.matrix.conversations,
                this.profileInfo.matrix.specialStats,
              ],
            },
          ],
        };

      });
  }

  public userGallery: any = [];
  public getUserGallery() {
    this.customerService
      .userGallery({ userId: this.profileInfo.id })
      .subscribe((response: any) => {
        this.userGallery = response.body;
      });
  }

  public handleSupportSeller() {
    if (!this.isLogin) {
      this.toastr.error('Please Login First!');
      return;
    }
    this.local
      .confirm({
        title: 'Support',
        text: `Do you wish to ${this.profileInfo.isSupport ? 'unsupport' : 'support'} this business?`,
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.profileInfo.id,
              type: 'community',
            })
            .subscribe({
              next: (response: any) => {
                // if (response.body) {
                //   this.profileInfo.isSupport = true;
                // } else {
                //   this.profileInfo.isSupport = false;
                // }
                this.profileInfo.isSupport = !this.profileInfo.isSupport
                this.toastr.success(response.message);
              },
              error: (e) => {
                this.toastr.error(e.error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });
  }

  private _getSubCategoryList(selectedSubCategoryName = '') {
    let selectedCategoryId = this._getSelectedCategoryId(); // Need update
    this.auth
      .getAllMemberShopSubCategory({
        categoryId: selectedCategoryId,
      })
      .subscribe((response: any) => {
        this.addedSubCategoryList = response.body;
        this.selectedSubCategoryName = '';
      });
  }
  private _getSelectedCategoryId(): any {
    return (
      this.addedCategoryList.filter(
        (i: any) => i.name == this.selectedCategoryName
      )[0]?.id || 0
    );
  }
  public onCategoryChange(catName, subCatName): void {
    this._getSubCategoryList(subCatName);
  }

  public productAllProductList: Array<any> = [];
  public productAllProductListFavorites: Array<any> = [];
  loadingProduct: boolean = true;
  public getAllProductList() {
    this.productAllProductList = [];
    // this.auth
    //   .getAllShopProduct()

    this.customerService
      .getAllShopProduct({
        categoryId: '',
        subCategoryId: '',
        userId: this.profileInfo.id,
      })
      .subscribe(
        (response: any) => {
          this.productAllProductList = response.body;
          this.productAllProductListFiltered = this.productAllProductList;
          this.loadingProduct = false;
        },
        (e) => {
          this.toastr.error(e.error.message);
          this.loadingProduct = false;
        }
      );


  }

  public getFavoriteProducts() {

    this.customerService.getFavoriteProducts({
      userId: this.profileInfo.id
    }).subscribe((resp: any) => {
      this.productAllProductListFavorites = resp.body;
      this.cdr.detectChanges();
    })
  }

  public selMenu: any = 0;
  public filterProp = 'type';
  public filterValue: any = 'shop';
  public selectMenu(menu: any): void {
    this.selMenu = menu;
    if (menu == 2) {
      this.filterProp = 'type';
      this.filterValue = 'rental';
    } else if (menu == 1) {
      this.filterProp = 'type';
      this.filterValue = 'shop';
    } else if (menu == 3) {
      this.filterProp = 'type';
      this.filterValue = 'bless';
    } else if (menu == 4) {
      this.filterProp = 'type';
      this.filterValue = 'sold';
    } else {
      this.filterProp = 'type';
      this.filterValue = '';
    }
  }

  public selMenu2: any = 0;
  public selectMenu2(menu: any): void {
    this.selMenu2 = menu;

    if (menu == 0) {
      this.getSupported();
    } else if (menu == 1) {
      this.getUserGallery();
    }
  }

  showImageGallery: any = {};
  openShowImageModal(modal, image) {
    this.showImageGallery = image;
    this.modalService.open(modal, {
      windowClass: 'my-show-image-modal',
    });
  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  timeout4: any;
  initMap(): void {
    this.local.clearTimeout(this.timeout4)
    this.timeout4 = setTimeout(() => {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 12,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62
          },
          strictBounds: true
        }
      });

      this.geocoder = new google.maps.Geocoder();

      if (this.postalCode != '') this.geocodePostalCode();
    }, 100);
  }

  placeMarkerAndPanTo(latLng: any): void {

    if (this.marker) {
      this.marker.setPosition(latLng);
    } else {
      this.marker = new google.maps.Marker({
        position: latLng,
        map: this.map,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62
          },
          strictBounds: true
        }
      });
    }
    this.map.panTo(latLng);
  }

  async geocodePostalCode(): Promise<void> {
    this.placeMarkerAndPanTo(await this.local.getLatLongByPostalCode(this.postalCode));
    // this.geocoder.geocode(
    //   { address: this.postalCode },
    //   (results: any, status: any) => {
    //     if (status === 'OK') {
    //       const location = results[0].geometry.location;
    //       const latLong = { lat: location.lat(), lng: location.lng() };

    //     } else {
    //     }
    //   }
    // );
  }

  public viewProductDetails(product): void {
    this.marketplaceProfileSection.enableMemberShop = product.enableMemberShop;
    this.marketplaceProfileSection.viewProduct(product);
  }

  public productAllProductListFiltered: Array<any> = [];
  public filterProduct(event: any) {
    this.productAllProductListFiltered = this.productAllProductList.filter(
      (product) => {
        return (
          product.name
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          product.description
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        );
      }
    );
  }

  public setProfileToDefault(type = 'default') {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to set your profile to default?',
      })
      .then((result) => {
        if (result.value) {
          this.customerService
            .setProfileToDefault({
              referralCode: this.profileInfo.referralCode,
              level: this.profileInfo.level,
              type: type,
            })
            .subscribe(
              (response: any) => {
                this.toastr.success(
                  response.message || 'Profile set to default successfully'
                );
                this.getProfileInfo(this.profileInfo.referralCode);
              },
              (e) => {
                this.toastr.error(
                  e.error.message || 'Failed to set profile to default'
                );
              }
            );
        }
      });
  }

  setProfileToAvatar() {
    this.setProfileToDefault('avatar');
  }

  public muteProfile() {
    this.customerService
      .updateUserMuteStatus({
        userId: this.profileInfo.id,
      })
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message || 'Profile muted successfully');
        },
        (e) => {
          this.toastr.error(e.error.message || 'Failed to mute profile');
        }
      );
  }

  public blockProfile() {
    this.customerService
      .updateUserBlockStatus({
        userId: this.profileInfo.id,
      })
      .subscribe(
        (response: any) => {
          this.toastr.success(
            response.message || 'Profile blocked successfully'
          );
        },
        (e) => {
          this.toastr.error(e.error.message || 'Failed to block profile');
        }
      );
  }

  public shareMyProfile(modal) {
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public copyReferralLink() {
    this.clipboard.copy(this.refer_friend_link);
    this.toastr.success('Profile Link Copied!');
  }

  public downloadQRCode() {
    const qrElement =
      this.qrcode.qrcElement.nativeElement.querySelector('canvas');

    if (qrElement) {
      const qrCodeDataUrl = qrElement.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = qrCodeDataUrl;
      link.download = 'qr-code.png';
      link.click();
    }
  }

  supported: any[] = [];
  getSupported() {
    this.customerService.getUserSupportList().subscribe((resp: ApiResponse) => {
      this.supported = resp.body.map((i: any) => {
        return {
          ...i,
          sellerImage:
            i.type == 'community'
              ? i.businessDetails?.profileCharacterImageFile
              : i.userDetails.shop_logo,
          sellerName:
            i.type == 'community'
              ? i.businessDetails?.profileCharacterName
              : i?.userDetails?.first_name + ' ' + i?.userDetails?.last_name,
        };
      });
    });
  }

  navigateToShop(item: any) {
    if (item.category == 'community') {
      this.router.navigate(['/profile', item.sellerReferralCode]);
    } else {
      if (item.sellerName == 'null') item.sellerName = null;
      this.router.navigate(['/biz', item.sellerName ?? item.sellerId]);
    }
  }
}
